export default "__VITE_ASSET__faf21a15__"